var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    style: {
      fill: "#ffffff",
      transform: "",
      msfilter: ""
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10H9v3H6v2h3v3h2v-3h3v-2h-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22h12c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2zM4 8h12l.002 12H4V8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2H8v2h12v12h2V4c0-1.103-.897-2-2-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxDuplicate);
export default __webpack_public_path__ + "static/media/BxDuplicate.ed83d8b91b1a9098739fd46bb2bc5be7.svg";
export { ForwardRef as ReactComponent };